import { TaxiReservationResponse } from "src/openapi";

type TaxiReservationStatus = 'rejected' | 'canceled' | 'fixed' | 'draft'
type TaxiReservationStatusOption = {
  name: string
}

export const taxiReservationStatusOptions: { [key in TaxiReservationStatus as string]: TaxiReservationStatusOption } = {
  rejected: {
    name: 'キャンセル(タクシー会社)',
  },
  canceled: {
    name: 'キャンセル(ユーザー)',
  },
  fixed: {
    name: '確定',
  },
  draft: {
    name: '仮予約',
  }
}

export function getTaxiReservationStatusName(taxiReservation: TaxiReservationResponse): string {
  const status = taxiReservation.status;
  return taxiReservationStatusOptions[status as TaxiReservationStatus]?.name || '';
}

export const taxiReservationPassengerCountOptions = [
  { value: 1, label: "1名" },
  { value: 2, label: "2名" },
  { value: 3, label: "3名" },
  { value: 4, label: "4名" },
  { value: 5, label: "5名以上" },
];

export function getTaxiReservationPassengerCountName(value: number): string {
  const option = taxiReservationPassengerCountOptions.find(option => option.value === value);
  return option ? option.label : '';
}
